<div class="event-drop">
    <div class="heading">
        <span class="title">{{bs.getResource('rbkey_UpcmngTrnngsLBL') | uppercase}}</span>
    
    </div>
    <app-loader *ngIf="loader"></app-loader>
    <div class="event-drop-inner" *ngIf="!loader">
        <div class="event-drop-box " *ngFor="let item of UpcomingTraining">
            <div class="event-drop-box-top white hand-cursor" (click)="openTraining(item['ILTID'],item['IsBlended'],item['CourseLaunchId'])">
                    <img src="assets/img/event-bg-1.jpg" alt="Image">
                <div class="date">
                    <span>{{item['SessionDay']}}</span>
                    {{item['SessionMonthYear']}}  
                </div>
                <div class="right-block">
                    <div class="inner-title" >{{item['ILTName'] | escape}}</div>
                    <div class="sub-title-middle">{{item['SessionName'] | escape}}</div>
                    <div class="sub-title">{{item['ILTVenue'] | escape}}</div>
                </div>
            </div>
            <div class="event-drop-box-bottom">
                <div class="btn-group">
                    <a href="javascript:void(0);" class="dropdown-toggle text-link">{{item['UserStatus']}}
                    </a>
         
                </div>
                <div class="right-text-int">{{item['UserCount']}} {{bs.getResource('rbkey_AttndngLbL')}} </div>
            </div>
        </div>
 
        <span class="span-no-item" *ngIf="TrainingCount == 0">{{bs.getResource('rbkey_NoItmToDsply')}}</span>
    </div>
    <div class="side-overlay box-overlay">
        <div class="inn-text">
            Drag and<br>
            Drop
        </div>
    </div>
</div>